import PropTypes from 'prop-types'
import React from 'react'
import { Item, List } from 'semantic-ui-react'

export default class Address extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  }

  formatZIP(zip) {
    return 'CH-' + zip
  }

  render() {
    const { data, noLinks = false } = this.props
    if (!data) return false
    return (
      <Item.Group>
        <Item>
          <Item.Content>
            {data.address_1 && <Item.Header>{data.address_1}</Item.Header>}
            {data.address1 && <Item.Header>{data.address1}</Item.Header>}
            <Item.Meta>
              <List>
                {data.address2 && <List.Item>{data.address2}</List.Item>}
                {data.address3 && <List.Item>{data.address3}</List.Item>}
                {data.address_2 && <List.Item>{data.address_2}</List.Item>}
                {data.address_3 && <List.Item>{data.address_3}</List.Item>}
                {data.postcode && data.place && (
                  <List.Item>
                    {data.postcode && this.formatZIP(data.postcode)}&nbsp;
                    {data.place}
                  </List.Item>
                )}
                {data.phone && (
                  <List.Item>
                    Tel.:{' '}
                    {noLinks ? (
                      data.phone
                    ) : (
                      <a href={`tel:${data.phone}`}>{data.phone}</a>
                    )}
                  </List.Item>
                )}
                {data.fax && (
                  <List.Item>
                    Fax:{' '}
                    {noLinks ? (
                      data.fax
                    ) : (
                      <a href={`tel:${data.fax}`}>{data.fax}</a>
                    )}
                  </List.Item>
                )}
                {data.email && (
                  <List.Item className="ellipsis">
                    {noLinks ? (
                      data.email
                    ) : (
                      <a href={`mailto:${data.email}`}>{data.email}</a>
                    )}
                  </List.Item>
                )}
              </List>
            </Item.Meta>
          </Item.Content>
        </Item>
      </Item.Group>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Helpers/Address.jsx